var EnumUtil = (function () {
    function EnumUtil() {
    }
    EnumUtil.getNumericValues = function (theEnum) {
        return Object.values(theEnum).filter(function (element) { return typeof element === "number"; });
    };
    return EnumUtil;
}());
export default EnumUtil;
//# sourceMappingURL=EnumUtil.js.map